import ElaborazioneGiornoPage from "./ElaborazioneGiornoPage";

export default function ElaborazioneCassaPage() {
  return <ElaborazioneGiornoPage forcedMode="cassa" />;
}
